import { Action } from '@ngrx/store';
import { GrupoKeycloak } from 'src/app/models/usuario/grupo-keycloak';

export enum UsuarioGrupoActionTypes {
  USUARIO_GRUPO_NEW = '[USUARIO_GRUPO_NEW] Add GRUPO',
  USUARIO_GRUPO_ALL = '[USUARIO_GRUPO_ALL] Get ALL',
}

export class UsuarioGrupoAll implements Action {
  readonly type = UsuarioGrupoActionTypes.USUARIO_GRUPO_ALL;
}

export class UsuarioGrupoAdd implements Action {
  readonly type = UsuarioGrupoActionTypes.USUARIO_GRUPO_NEW;
  constructor(public payload: { grupos: any }) {}
}

export type UsuarioGrupoActions = UsuarioGrupoAdd | UsuarioGrupoAll;
